import { FaBuilding } from 'react-icons/fa';

export function BuildingIcon({ className }: { className?: string }) {
  return <FaBuilding className={`text-[1rem] text-[#FBBF24] ${className}`} />;
}
